/* Storefront-only custom events. Reuse the existing Google & YouTube tag.
 * No tag loader/config, pixels, customer identifiers or standard events here.
 * An accepted/handed-off event is NOT proof of receipt in GA4.
 */
(() => {
  'use strict';
  if (window.PawCustomizerAnalytics) return;
  const DESTINATION = 'G-CQ6MVLSMKD';
  const GOOGLE_TAGS = [DESTINATION, 'GT-NML4MGSB'];
  const STEP_NAMES = ['pet_details', 'photos', 'options', 'timing', 'summary'];
  const REASONS = ['too_large', 'unsupported_type', 'image_decode', 'upload_failed'];
  const queue = [], seen = new Set();
  const counts = {accepted: 0, shopifyPublished: 0, googleHandedOff: 0, dropped: 0};
  let timer = null, config = null;
  try { config = JSON.parse(document.getElementById('pc-design-config').textContent); } catch {}

  function allowed() {
    if (!config || config.local || config.preview) return false;
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
    catch { return false; }
  }
  function sanitize(name, input) {
    if (!input || typeof input !== 'object') return null;
    const product = ['figurine', 'keychain'].includes(input.product) ? input.product : null;
    if (name === 'customizer_step') {
      const n = input.step_number;
      if (!product || !Number.isInteger(n) || n < 1 || n > 5) return null;
      return {step_number: n, step_name: STEP_NAMES[n - 1], product};
    }
    if (name === 'customizer_submit') {
      if (!product || !['yes', 'no'].includes(input.rush)) return null;
      return {product, rush: input.rush};
    }
    if (name === 'photo_upload_failed' && REASONS.includes(input.reason)) return {reason: input.reason};
    return null;
  }
  function tagReady() {
    if (typeof window.gtag !== 'function') return false;
    // Do not mistake a different/iframe tag or an unrelated stub for this tag.
    return Array.from(document.querySelectorAll('script[src]')).some(script => {
      try {
        const url = new URL(script.src);
        return url.hostname === 'www.googletagmanager.com' && url.pathname === '/gtag/js' && GOOGLE_TAGS.includes(url.searchParams.get('id'));
      } catch { return false; }
    });
  }
  function stopTimer() { if (timer !== null) clearTimeout(timer); timer = null; }
  function dropAll() { counts.dropped += queue.length; queue.length = 0; stopTimer(); }
  function flush() {
    stopTimer();
    if (!allowed()) { dropAll(); return; }
    const ready = tagReady();
    for (let i = 0; i < queue.length;) {
      const item = queue[i];
      if (Date.now() - item.at >= 10000) { queue.splice(i, 1); counts.dropped++; continue; }
      if (!ready) { i++; continue; }
      // Consume once before calling a third-party SDK: a throw after enqueue
      // cannot safely be retried without risking a duplicate event.
      queue.splice(i, 1);
      if (!allowed()) { counts.dropped++; dropAll(); return; }
      try {
        window.gtag('event', item.name, {
          ...item.data, send_to: DESTINATION,
          // Event-scoped blanks avoid copying a customizer URL/referrer/title.
          // Confirm final /g/collect payload after deployment, not just this call.
          page_location: '', page_referrer: '', page_title: ''
        });
        counts.googleHandedOff++;
      } catch { counts.dropped++; }
    }
    if (queue.length) timer = setTimeout(flush, 200);
  }
  function emit(name, input, interactionKey) {
    const data = sanitize(name, input);
    if (!data || !allowed()) return false;
    let key = '';
    if (name === 'customizer_step') key = name + ':' + data.product + ':' + data.step_number;
    else if (typeof interactionKey === 'string' && interactionKey.length <= 160) key = name + ':' + interactionKey;
    if (key && seen.has(key)) return false;
    if (queue.length >= 30) return false;
    if (key) seen.add(key);
    counts.accepted++;
    // Preserve Shopify's custom event bus for other consumers. Do not add a
    // second GA4 subscriber for these names: Google delivery is owned here.
    try {
      if (typeof window.Shopify?.analytics?.publish === 'function' && window.Shopify.analytics.publish(name, {...data}) !== false) counts.shopifyPublished++;
    } catch {}
    queue.push({name, data, at: Date.now()});
    flush();
    return true; // Accepted locally, not GA4 acknowledgement.
  }
  document.addEventListener('visitorConsentCollected', flush);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', flush);
  window.PawCustomizerAnalytics = Object.freeze({
    emit,
    snapshot: () => ({...counts, pending: queue.length, analyticsAllowed: allowed(), tagPresent: tagReady()})
  });
})();
